var map = {
	"./tag1.png": 46400,
	"./tag10.png": 66480,
	"./tag11.png": 95340,
	"./tag12.png": 90291,
	"./tag13.gif": 95177,
	"./tag14.png": 2528,
	"./tag15.png": 35278,
	"./tag16.png": 30522,
	"./tag2.png": 61414,
	"./tag3.gif": 87398,
	"./tag3.png": 49347,
	"./tag4.png": 4028,
	"./tag5.png": 86109,
	"./tag6.png": 5910,
	"./tag7.png": 85585,
	"./tag8.png": 86314,
	"./tag9.png": 4748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85393;